<template>
  <div
    v-infinite-scroll="uploadMore"
    :infinite-scroll-distance="scrollDistance"
    infinite-scroll-disabled="busy"
    class="pagination-container"
  >
    <slot />
    <Spinner v-show="busy" size="40" />
  </div>
</template>

<script>
  import request from '@/utils/api/request';
  import infiniteScroll from 'vue-infinite-scroll';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'Pagination',
    components: {
      Spinner,
    },
    directives: { infiniteScroll },
    model: {
      prop: 'items',
      event: 'upload',
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      url: {
        type: [String, null],
        default: null,
      },
    },
    data() {
      return {
        nextUrl: null,
        busy: false,
        scrollDistance: window.innerHeight / 2,
      };
    },
    watch: {
      url(value) {
        this.nextUrl = value;
        let isScrollOnThePage = !!document.documentElement.scrollHeight;
        if (!isScrollOnThePage && value) {
          this.uploadMore();
        }
      },
    },
    methods: {
      async uploadMore() {
        if (this.nextUrl) {
          this.busy = true;
          try {
            let { data } = await request(this.nextUrl);

            await this.$emit('upload', [...this.items, ...data.results]);
            this.nextUrl = data.next;
          } catch (e) {
            console.error(e);
          }
          this.busy = false;
        }
      },
    },
  };
</script>
